import {Injectable} from '@angular/core';
import {CoefService} from './coef.service';
import {HttpClient} from '@angular/common/http';
import {baseUrl, PAGE} from '../router.path';
import * as _ from 'lodash';
import {CoefDoorService} from './door service/coef-door.service';
import {PriceService} from './price.service';
import {InitRenderService} from './renderingService/init-render.service';
import {RoutStepService} from './rout-step.service';
import {Router} from '@angular/router';
import {NotificationService} from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class ParserService {
  objectToPars: Object = {};

  constructor(
    private coef: CoefService,
    private http: HttpClient,
    private coefDoor: CoefDoorService,
    private price: PriceService,
    private render: InitRenderService,
    private rout: RoutStepService,
    private router: Router,
    private notification: NotificationService
  ) {
  }

  private setSettingParams(): void {
    return this.arrayToObjectParams(['width', 'height', 'depth', 'order_type_id'], 'setingsWardrobe');
  }

  private setSecondParams(): void {
    return this.arrayToObjectParams([
      'scheme_id', 'lamp_id', 'init_option_ids', 'system_color_id', 'colorID', 'facade_color_id',
      'deleted_older_content_square', 'deleted_older_content_elements', 'global_coef', 'legs_count', 'comment'
    ]);
  }

  private arrayToObjectParams(array, path = null): void {
    for (let i = 0; i < array.length; i++) {
      this.objectToPars[array[i]] = path ? this.coef[path][array[i]] : this.coef[array[i]];
    }
  }


  private setContent(Layerw, contentString , wardrobe?): void {
    for (const item of Layerw.children) {
      if (item.attrs.params && item.attrs.params.type === 15) {
        if (item.attrs.params.position == 'left') {
          if (item.children[1].attrs.width < 0) {
            item.attrs.width = item.children[1].attrs.width * -1;
          }
        }
      }
    }
    this.price.sendObjectPrice();
    this.objectToPars['door_count'] = [...this.coef.doorsArray];
    const content = _.cloneDeep(Layerw.children.map(children => {
      return _.cloneDeep(children.attrs);
    }));
    for (let i = 0; i < content.length; i++) {
      for (const obj in content[i].params) {
        if (_.isObject(content[i].params[obj])) {
          if (obj === 'shelfPositions' || obj === 'older') {

          } else if (obj === 'hingeBind' && Array.isArray(content[i].params[obj])) {
            // type 17: масив посилань на петлі → плоский scalar-масив координат.
            content[i].params[obj] = content[i].params[obj]
              .filter((h: any) => h && h.attrs && h.attrs.params && h.attrs.params.isHinge)
              .map((h: any) => ({
                x: h.attrs.x,
                y: h.attrs.y,
                width: h.attrs.width,
                height: h.attrs.height,
                orientation: h.attrs.params.orientation || null,
                hinge_index: h.attrs.params.hingeIndex != null ? h.attrs.params.hingeIndex : null,
                opening_type: h.attrs.params.openingType || 'common',
                hinge_type: this.coef.hingedFactory ? this.coef.hingedFactory.hingeTypeOf(h) : null
              }));
          } else if (obj === 'drawerZoneBind' && Array.isArray(content[i].params[obj])) {
            // type 17: scalar-форма зон шухляд для бекенду.
            content[i].params[obj] = content[i].params[obj]
              .filter((z: any) => z && z.attrs && z.attrs.params && z.attrs.params.isDrawerZone)
              .map((z: any) => {
                const bg = z.children && z.children[0];
                return {
                  x: z.attrs.x,
                  y: z.attrs.y,
                  width: bg ? (bg.attrs.width || 0) : 0,
                  height: bg ? (bg.attrs.height || 0) : 0,
                  drawer_sub_id: z.attrs.params.drawerSubId != null ? z.attrs.params.drawerSubId : null,
                  door_key: z.attrs.params.doorKey != null ? z.attrs.params.doorKey : null
                };
              });
          } else {
            delete content[i].params[obj];
          }
        }
      }
      if (content[i].bind) {
        for (let j = 0; j < content[i].bind.length; j++) {
          for (const obj in content[i].bind[j].attrs.params) {
            if (_.isObject(content[i].bind[j].attrs.params[obj])) {
              if (obj !== 'shelfPositions') {
                delete content[i].bind[j].attrs.params[obj];
              }
            }
          }
          content[i].bind[j] = content[i].bind[j].attrs;
          if (content[i].bind[j].bind) {
            delete content[i].bind[j].bind;
          }
        }
      }
    }
    this.objectToPars[contentString] = content;
  }


  // setDoor(Layerw) {
  //   const content = _.cloneDeep(Layerw);
  //   delete content.attrs.sceneFunc;
  //   if (content.attrs.hitFunc) {
  //     delete content.attrs.hitFunc;
  //     delete content.attrs.image;
  //   }
  //   return content.attrs;
  // }
  setDoor(Layerw) {
    
    const content = this.copyIntStringParams(Layerw.attrs);
    content['params'] = this.copyIntStringParams(Layerw.attrs.params);
    return content;
  }
  copyIntStringParams(source) {
    const result = {};

    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            const value = source[key];
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                result[key] = value;
            }
        }
    }

    return result;
}

  sendDoor() {
    // this.objectToPars['scheme_id'] = this.coefDoor.colorSystemId;
    this.objectToPars['system_id'] = this.coefDoor.systemId;
    // type 17 — наш формат фасадів (плоский список) замість matetials/content/separators.
    console.log('[SEND-DOOR parser]', {
      pramsId_raw: this.coef.pramsId,
      pramsId_num: +this.coef.pramsId,
      is_17: +this.coef.pramsId === 17,
      has_hingedFactory: !!this.coef.hingedFactory
    });
    if (+this.coef.pramsId === 17) {
      const facades = this.coef.hingedFactory
        ? this.coef.hingedFactory.collectFacadesForBackend()
        : [];
      const tree = this.coef.hingedFactory
        ? this.coef.hingedFactory.collectFacadeTreeForBackend()
        : [];
      console.log('[SEND-DOOR parser] BRANCH 17 ENTERED', {facades_count: facades.length, tree_roots: tree.length});
      // Дерево пакуємо у door_count як спеціальний елемент з visual_only=true.
      // Backend ігнорує його при парсингу для виробництва, але зберігає у масиві і
      // повертає назад на edit — ми його дістаємо для restoreFromTree.
      facades.push({ visual_only: true, facade_tree: tree });
      this.objectToPars['door_count'] = facades;
      return;
    }
    let index = 0;
    for (const door of this.objectToPars['door_count']) {
      index = index + 1;
      door.materials = [];
      door.content = [];
      door.y = this.coef.topPositaionWrapper;
      door.separators = [];
      for (const elem of this.coefDoor.DoorWrapper.children) {
        if (elem.attrs.params && elem.attrs.params.type === index && elem.attrs.params.price) {
          door.door_type_id = elem.attrs.params.typeDoor;
          door.materials.push(elem.attrs.params.id);
          door.content.push(this.setDoor(elem));
        }
        if (elem.attrs.params && elem.attrs.params.type === index && elem.attrs.params.part) {
          door.separators.push(this.setDoor(elem));
        }
      }
      if (this.coefDoor.sepArray.includes(door.door_type_id)) {
        door.sep_count = door.materials.length - 1;
      } else {
        door.sep_count = 0;
      }
    }
  }

  public async sendInfo(): Promise<void> {
    this.setSettingParams();
    this.setSecondParams();
    this.setContent(this.coef.shapesLayerw, 'content');

    this.sendDoor();
    // ВАЖЛИВО: await щоб дочекатись composite (для type 17) перш ніж зафіксувати
    // facadeImage у payload. Без await — у backend пішла б ТІЛЬКИ sync БАЗА без петель.
    await this.createImg();
    this.objectToPars['contentImage'] = this.coef.contentImage;
    this.objectToPars['facadeImage'] = this.coef.facadeImage;
    this.objectToPars['system_color_id'] = this.coefDoor.colorSystemId;
    this.objectToPars['stoper'] = this.coefDoor.stoperDoor;
    this.objectToPars['puller'] = this.coefDoor.puller;
    this.objectToPars['roller'] = this.coefDoor.rollerDoor;
    this.objectToPars['system_color_id'] = this.coefDoor.colorSystemId;
    if (this.coef.pramsId == 13 || this.coef.pramsId == 2 || this.coef.pramsId == 15) {
      this.objectToPars['content'] = [];
    }
    if (this.coef.pramsId == 13) {
      this.objectToPars['colorID'] = null;
    }
    if (this.coef.arrayNotFacadColor.includes(this.coef.pramsId)) {
      this.objectToPars['facade_color_id'] = null;
    }
    if (this.coef.arrayNotSystemColor.includes(+this.coef.pramsId)) {
      this.objectToPars['system_color_id'] = null;
    }
    if (this.coef.pramsId == 2 || this.coef.pramsId == 15) {
      const objects = {
        leftCorner: this.coef.setingsWardrobe.content_object['leftCorner'].subId == 'null' ? null : this.coef.setingsWardrobe.content_object['leftCorner'],
        rightCorner: this.coef.setingsWardrobe.content_object['rightCorner'].subId == 'null' ? null : this.coef.setingsWardrobe.content_object['rightCorner'],
      };
      this.objectToPars['content'].push(objects);
    }
    if (this.coef.end_client) {
      this.objectToPars['user'] = Number(this.coef.end_client);
    }
    console.log(this.objectToPars);
    if (this.render.changeSize && this.render.object) {
      this.objectToPars['orderId'] = this.render.object.id;
      this.render.changeSize = false;
      this.http.post(baseUrl.api + 'edit-order', this.objectToPars).subscribe(res => {
        if (res['success']) {
          this.coef.preloaderUpdate(false);
          this.notification.triggerNotification(res['payload'], false);
          this.router.navigate([PAGE.ORDER]);
        }
      }, (error) => {
        if (error.status === 401) {
          this.router.navigate(['']);
        }
      });
    } else {
      this.http.post(baseUrl.api + 'save-order', this.objectToPars).subscribe(res => {
        if (res['success']) {
          this.coef.preloaderUpdate(false);
          this.notification.triggerNotification(res['payload'], false);
          this.router.navigate([PAGE.ORDER]);
        }
      }, (error) => {
        if (error.status === 401) {
          this.router.navigate(['']);
        } else {
          this.coef.preloaderUpdate(false);
        }
      });
    }
  }

  deleteObject() {
    this.http.get(baseUrl.api + `cancel-order/${this.render.object.id}`).subscribe(res => {
      if (res['success']) {
        this.coef.preloaderUpdate(false);
        this.notification.triggerNotification(res['payload'], false);
        this.router.navigate([PAGE.ORDER]);
      }
    }, (error) => {
      if (error.status === 401) {
        this.router.navigate(['']);
      }
    });
    ;
  }


  public async reSendInfo(): Promise<void> {
    this.setSettingParams();
    this.setSecondParams();
    this.setContent(this.coef.shapesLayerw, 'content');
    this.sendDoor();
    // ВАЖЛИВО: await щоб дочекатись composite (див. коментар у sendInfo).
    await this.createImg();
    this.objectToPars['contentImage'] = this.coef.contentImage;
    this.objectToPars['facadeImage'] = this.coef.facadeImage;
    this.objectToPars['system_color_id'] = this.coefDoor.colorSystemId;
    this.objectToPars['orderId'] = this.render.object.id;
    this.objectToPars['init_option_ids'] = this.render.object.init_option_ids;
    this.objectToPars['lamp_id'] = this.render.object.lamp_id;
    this.objectToPars['stoper'] = this.coefDoor.stoperDoor;
    this.objectToPars['puller'] = this.coefDoor.puller;
    this.objectToPars['roller'] = this.coefDoor.rollerDoor;
    this.objectToPars['scheme_id'] = this.render.object.scheme_id;
    if (this.coef.pramsId == 13 || this.coef.pramsId == 2 || this.coef.pramsId == 15) {
      this.objectToPars['content'] = [];
    }
    if (this.coef.pramsId == 13) {
      this.objectToPars['colorID'] = null;
    }
    if (this.coef.arrayNotFacadColor.includes(this.coef.pramsId)) {
      this.objectToPars['system_color_id'] = null;
    }
    if (this.coef.arrayNotSystemColor.includes(+this.coef.pramsId)) {
      this.objectToPars['system_color_id'] = null;
    }
    console.log(this.objectToPars, 'objectToParsrender');
    this.http.post(baseUrl.api + 'edit-order', this.objectToPars).subscribe(res => {
      if (res['success']) {
        this.coef.preloaderUpdate(false);
        this.notification.triggerNotification(res['payload'], false);
        this.router.navigate([PAGE.ORDER]);
      }
    }, (error) => {
      if (error.status === 401) {
        this.router.navigate(['']);
      }
    });
  }

  async createImg(): Promise<void> {
    if (this.coefDoor.DoorWrapper) {
      if (this.coefDoor.reDesign) {
        this.coefDoor.reDesign.attrs.strokeWidth = 1;
        this.coefDoor.reDesign.attrs.stroke = 'black';
        // Type 17: червоне обведення вибраного фасаду ставиться на ВНУТРІШНІЙ rect (group.children[0]),
        // не на сам group. Ресетимо і його.
        const innerRect = this.coefDoor.reDesign.children && this.coefDoor.reDesign.children[0];
        if (innerRect && innerRect.attrs) {
          innerRect.attrs.strokeWidth = 1;
          innerRect.attrs.stroke = 'black';
        }
        // this.coefDoor.reDesign = false;
      }
      if(this.coefDoor.manualTravelElement){
        this.coefDoor.manualTravelElement.attrs.fill = this.coefDoor.colorSystem;
        this.coefDoor.manualTravelElement.attrs.stroke = 'black';
        // this.coefDoor.manualTravelElement = false;
      }
      this.coefDoor.DoorWrapper.batchDraw();
      // Спочатку синхронна БАЗА — щоб Angular одразу мав щось показати у third-stage <img>.
      // Потім для type 17 await'имо композит з петлями і власними dim-вузлами.
      this.coef.facadeImage = this.coefDoor.DoorWrapper.toDataURL('png', 1);
      // Type 17: замовник не хоче петель на картинці фасадів — композит вимкнено (лишається база).
      // if (+this.coef.pramsId === 17 && this.coef.hingedFactory
      //     && typeof this.coef.hingedFactory.composeFacadeImageWithHinges === 'function') {
      //   try {
      //     const url = await this.coef.hingedFactory.composeFacadeImageWithHinges();
      //     if (url) this.coef.facadeImage = url;
      //   } catch (e) {
      //     console.warn('[createImg] composite facadeImage failed', e);
      //   }
      // }
    }
    if (this.coef.stage) {
      if (this.coef.manualTravelElement) {
        this.coef.manualTravelElement.attrs.strokeWidth = 1;
        this.coef.manualTravelElement.stroke('black');
      }
      // СИНХРОННО: ховаємо outlines + робимо кнопку білою, відразу робимо знімок, відразу
      // відновлюємо. Без setTimeout — щоб не було race conditions між паралельними викликами
      // createImg() (їх може бути 2-4 за коротенький час: на tab select + з price + з parser).
      const factory = this.coef.hingedFactory;
      const outlinesGroup = factory && factory.facadeOutlinesGroup;
      const btnGroup = factory && factory.facadeToggleButton;
      const btnBg = btnGroup && btnGroup.children && btnGroup.children[0];
      const btnLabel = btnGroup && btnGroup.children && btnGroup.children[1];
      const hintsLayer = factory && factory.facadeHintsLayer;

      // Зберігаємо попередні стани (на момент ПЕРЕД будь-якими нашими змінами).
      const prevOutlinesVisible = outlinesGroup && typeof outlinesGroup.visible === 'function' ? outlinesGroup.visible() : null;
      const prevBtnBgFill = btnBg && typeof btnBg.fill === 'function' ? btnBg.fill() : null;
      const prevBtnBgStroke = btnBg && typeof btnBg.stroke === 'function' ? btnBg.stroke() : null;
      const prevBtnLabelFill = btnLabel && typeof btnLabel.fill === 'function' ? btnLabel.fill() : null;

      // 1. Ховаємо
      if (outlinesGroup && typeof outlinesGroup.visible === 'function') outlinesGroup.visible(false);
      if (btnBg && typeof btnBg.fill === 'function') btnBg.fill('white');
      if (btnBg && typeof btnBg.stroke === 'function') btnBg.stroke('white');
      if (btnLabel && typeof btnLabel.fill === 'function') btnLabel.fill('white');

      // 2. Синхронний redraw — layer.draw() (не batchDraw, бо той async через rAF)
      if (hintsLayer && typeof hintsLayer.draw === 'function') hintsLayer.draw();
      if (this.coef.stage.stage && typeof this.coef.stage.stage.draw === 'function') this.coef.stage.stage.draw();

      // 3. Знімок одразу — canvas вже містить hidden-стан після draw()
      this.coef.contentImage = this.coef.stage.stage.toDataURL('png', 1);

      // 4. Відновлюємо
      if (outlinesGroup && typeof outlinesGroup.visible === 'function' && prevOutlinesVisible != null) {
        outlinesGroup.visible(prevOutlinesVisible);
      }
      if (btnBg && typeof btnBg.fill === 'function' && prevBtnBgFill != null) btnBg.fill(prevBtnBgFill);
      if (btnBg && typeof btnBg.stroke === 'function' && prevBtnBgStroke != null) btnBg.stroke(prevBtnBgStroke);
      if (btnLabel && typeof btnLabel.fill === 'function' && prevBtnLabelFill != null) btnLabel.fill(prevBtnLabelFill);

      // 5. Redraw з відновленим станом (тут можна batchDraw — некритично)
      if (hintsLayer && typeof hintsLayer.batchDraw === 'function') hintsLayer.batchDraw();
      this.coef.stage.stage.batchDraw();
    }
  }
}

